import { httpService } from '@services/http';
import { HttpService } from '@services/http/http';

// import { skeepersRepository as skeepersRepositoryV2 } from '@repositories/skeepers';
import { skeepersRepositoryV2 as skeepersRepository } from '@repositories/skeepers-v2';

import { ReviewAverageType, ReviewsInfoType } from '@app-types/review';

import { isServer } from '@helpers/config';
import { localApiPaths } from '@helpers/path';

export class ReviewsServices {
    private httpService: HttpService;

    public constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    public async getAverageReviews(gencodes: string[]): Promise<ReviewAverageType[] | undefined> {
        if (isServer()) {
            return this.getAverageReviewsServer(gencodes);
        }

        return this.httpService
            .post<ReviewAverageType[] | undefined>(localApiPaths.reviews, {
                gencodes,
            })
            .catch(() => undefined);
    }

    private async getAverageReviewsServer(gencodes: string[]): Promise<ReviewAverageType[] | undefined> {
        return skeepersRepository.getAverageReviews(gencodes);
    }

    public async getReviews(
        gencode: string,
        offset: number = 0,
        limit: number = 5,
    ): Promise<ReviewsInfoType | undefined> {
        if (isServer()) {
            return this.getReviewsServer(gencode, offset, limit);
        }

        return this.httpService
            .get<ReviewsInfoType | undefined>(localApiPaths.reviews, {
                gencode,
                offset: offset.toString(),
                limit: limit.toString(),
            })
            .catch(() => undefined);
    }

    private async getReviewsServer(
        gencode: string,
        offset: number = 0,
        limit: number = 5,
    ): Promise<ReviewsInfoType | undefined> {
        return skeepersRepository.getReviews(gencode, offset, limit);
    }
}

export const reviewsServices = new ReviewsServices(httpService);
